import { render, staticRenderFns } from "./partyYearsReport.vue?vue&type=template&id=770fcf28"
import script from "./partyYearsReport.vue?vue&type=script&lang=js"
export * from "./partyYearsReport.vue?vue&type=script&lang=js"
import style0 from "./partyYearsReport.vue?vue&type=style&index=0&id=770fcf28&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports